<script setup lang="ts">
  import { VueFinalModal } from 'vue-final-modal';
  // Components
  import { UiModalHeader, IconImage } from '@/shared/ui';
  import ModalActions from '@/shared/ui/modals/ModalActions.vue';
  // Icons
  import TrashIcon from '@/shared/assets/icons/RedTrashIcon.svg';

  withDefaults(
    defineProps<{
      title: string;
      description: string;
      isDeleting?: boolean;
      icon?: string | object;
      iconAlt?: string;
    }>(),
    {
      icon: TrashIcon,
      iconAlt: 'Trash',
    }
  );

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'confirm'): void;
  }>();

  const handleClose = () => {
    emit('close');
  };

  const handleConfirm = () => {
    emit('confirm');
  };
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    content-class="flex flex-col bg-white-01 rounded-2xl max-w-md w-full mx-4"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <UiModalHeader
      class="px-6 py-4 text-sm"
      @close="handleClose"
    />
    <div
      id="modal-content"
      class="flex flex-col px-14 pb-10"
    >
      <IconImage
        :src="icon"
        :alt="iconAlt"
        class="w-6 h-6 mb-7 mx-auto"
      />
      <p class="text-center text-base whitespace-pre-line">
        {{ title }}
      </p>
      <p class="text-center text-base text-gray-03 whitespace-pre-line">
        {{ description }}
      </p>
      <ModalActions
        class="mt-8"
        :confirm-disabled="isDeleting"
        :confirm-loading="isDeleting"
        @close="handleClose"
        @confirm="handleConfirm"
      />
    </div>
  </VueFinalModal>
</template>
